import { TabLabel } from '@app/fallback-report/table-nav/table-nav.component';
import { FallbackReportService } from '@app/fallback-report/local-service/fallback-report.service';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export declare type Enum = { [key: string]: number };

/**
 * concrete dependents of class are configured in the index.ts file to be
 * loaded by the local service (FallbackReportService). see the readme file for
 * details
 */
export abstract class FallbackReportExtension {
  abstract opCo: string;
  abstract TableNavOverrides?: { [endpoint: string]: string /* label */ };
  abstract DataFields: { [endpoint: string]: Array<string> /* field definitions */ };
  abstract TableRowHeaders: { [endpoint: string]: Array<string> /* field definitions */ };
  abstract TableCelStyles: { [endpoint: string]: { [datafield: string]: number /* tab style enum*/} };
  abstract TabLabels: Array<TabLabel>;
  abstract DataEndpoint: {[endpoint: string]: string /* uri path */};

  abstract TableStyle: {[endpoint: string]: number };

  accept(service: FallbackReportService) {
    service.TabLabels = this.TabLabels;
    service.DataFields = this.DataFields;
    service.TableRowHeaders = this.TableRowHeaders;
    service.TableCelStyles = this.TableCelStyles;

    service.TableStyle = this.TableStyle;
    service.DataEndpoint = this.DataEndpoint;
  }
}
